module.exports = __webpack_public_path__ + "img/62400.912cbb7f.jpg";